import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-bg3",
  "use": "icon-bg3-usage",
  "viewBox": "0 0 1200 701",
  "content": "<symbol xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1200 701\" id=\"icon-bg3\">\r\n  <g transform=\"matrix(1 0 0 1 0 -3790 )\">\r\n    <path d=\"M 0 701  L 0 0  L 608.925619834711 123  L 1200 0  L 1200 701  L 0 701  Z \" fill-rule=\"nonzero\" fill=\"#edf8ff\" stroke=\"none\" transform=\"matrix(1 0 0 1 0 3790 )\" />\r\n  </g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/bg3.svg
// module id = qfzz
// module chunks = 0